import { select } from 'd3';
import '../styles/_main.scss';
import "./components.imports.ts";
import { DataCache } from './data/utils/Cache.ts';
import { _Init } from './data/utils/General.ts';
import { OnHashChangeController } from './routes/UIManager.ts';
import { LOADING } from './ui/components/Loading.ts';
import { BotSendError } from './utils/AlertBot.ts';
import { _IS_SAFARI_NAVIGATOR, _LoadAPPInfo } from './utils/Device.ts';

function InitAPP() {
    if (import.meta.env.PROD)
        window.addEventListener("contextmenu", function (e) { e.preventDefault(); })
    if (_IS_SAFARI_NAVIGATOR)
        document.body.classList.add('safari-browser');

    if (!IsOnLine())
        return;

    window.onhashchange = OnHashChangeController;

    _Init()
        .then(() => {
            LOADING.Show();
            _LoadAPPInfo();
            DataCache._CleanExpiredCache();
        });
}

function IsOnLine(): boolean {
    let divLauncher = select(".launcher");
    if (!navigator.onLine) {
        divLauncher.append("h3")
            .text("No hay acceso a internet")
            .classed("title", true);
    } else {
        divLauncher.remove();
    }

    return navigator.onLine;
}

window.onload = () => {
    if (!window.innerHeight || !window.innerWidth) {
        console.info("fail window size > height: ", window.innerHeight, ", width: ", window.innerWidth);
        window.onresize = () => OnResize();
        return;
    }
    setTimeout(() => InitAPP(), 100);
}

window.onerror = (_message, _filename, _lineno, _colno, error) => {
    if (error) BotSendError(error);
}

function OnResize() {
    window.onresize = null;
    setTimeout(() => InitAPP(), 100);
}